import styled from "styled-components";

export const Wrapper = styled.div`
  height: 100%;
  .ant-layout {
    height: 100%;
    // background: rgb(224, 228, 233);
    background:#EFF3F6;
  }
  .demo-logo-vertical {
    padding: 20px;
    position: relative;
    // display: flex;
    // align-items: center;
    justify-content: center;
    margin:0px;
    background: rgb(255 255 255 / 0%);
    border-bottom: 1px solid #ebeff2;
    border-right: 1px solid #ebeff2;
  }
  .ant-layout-content{     
    padding-left: 10px !important;
    padding-right: 10px !important;
    padding-top: 10px;
  }
    .ant-layout-footer {
    padding: 14px 50px 5px 10px;
    color: rgba(0, 0, 0, 0.88);
    font-size: 14px;
    background: #ffffff;
    text-align: left !important;
}


  
`;
